import moment from 'moment-timezone'

export const isShortDuration = (event) => {
  if (!event.AllDay) {
    return moment(event.EndTime).diff(moment(event.StartTime), 'minute') <= 30
  }
  return false
}
